import React from "react";
import { FilePicker } from "../../pages/ImageUploads/components";
import { MobilePhotoAction } from "../../data/MobilePhotoAction";

export const MobilePhotoActions = ({
  imageQuantityRequired,
  onChange,
  uploadMore,
  labelIdentifier,
  disable
}: {
  imageQuantityRequired: number;
  onChange: () => void;
  uploadMore: boolean;
  labelIdentifier: string | null;
  disable: boolean;
}) => {
  return (
    <div className="ch-width--12 sl:ch-width--8 sm:ch-width--6 md:ch-width--5 lg:ch-width--4 ch-mh--auto">
      <div className="ch-mb--2">
        <FilePicker
          buttonLabel={`Take photo${imageQuantityRequired > 1 ? "s" : ""}`}
          buttonClass="ch-btn--success ch-btn--block mobile-take-photo"
          handleChange={onChange}
          uploadMore={uploadMore}
          labelIdentifier={`${labelIdentifier}-${MobilePhotoAction.TAKE_PHOTO}`}
          disable={disable}
          mobileAction={MobilePhotoAction.TAKE_PHOTO}
        />
      </div>
      <div>
        <FilePicker
          buttonLabel={`Photo library`}
          buttonClass="ch-btn ch-btn--block ch-ba--1 mobile-photo-library"
          handleChange={onChange}
          uploadMore={uploadMore}
          labelIdentifier={`${labelIdentifier}-${MobilePhotoAction.UPLOAD_PHOTO}`}
          disable={disable}
          mobileAction={MobilePhotoAction.UPLOAD_PHOTO}
        />
      </div>
    </div>
  );
};
